import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { activityActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { activity } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setActivityList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentActivity = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionActivity = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const activityReducer = createReducer(activity, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setActivityList,
  [actions.CURRENT]: setCurrentActivity,
  [actions.CUD]: actionActivity,
});
